export default __webpack_public_path__ + "static/media/baac.acb780e7.svg";